export class WalkinTimesController {
  constructor(private _walkinTimes: any) {}
}

angular.module('capability-ng-appointments').controller('WalkinTimesController', WalkinTimesController);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/views/walkin_times/walkin_times_controller.ts